import React, { useEffect } from 'react';
import '../styles/TermsConditions.css';

const TermsConditions = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
    const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918977772819?text=${encodedMessage}`;
    
  return (
    <section className="terms-conditions-page">
      <div className="terms-conditions-header">
        <h1 className="terms-conditions-title"><span className='highlight'>Terms</span> and <span className='highlight'>Conditions</span></h1>
        <p className="terms-conditions-update-date">Last Updated: 20/12/2024</p>
      </div>

      <div className="terms-conditions-content">
        <p>
          Welcome to Reddy Anna Book Official. By accessing and using our
          platform, you agree to comply with the terms and conditions outlined
          below. Please read this document carefully to ensure a clear
          understanding of your rights and obligations while using our
          services.
        </p>

        <p>
          <strong>1. Acceptance of Terms: </strong>
          By accessing or using Reddy Anna Book Official, you acknowledge that
          you have read, understood, and agree to be bound by these terms and
          conditions. If you do not agree with any part of these terms, please
          refrain from using our platform.
        </p>

        <p>
          <strong>2. User Registration: </strong>
          To access certain features, you may be required to register an
          account. You are responsible for maintaining the confidentiality of
          your account credentials and ensuring that they are used only by you.
        </p>

        <p>
          <strong>3. Age Restrictions: </strong>
          You must be of legal gambling age in your jurisdiction to use our
          services. By using Reddy Anna Book Official, you confirm that you
          meet the legal age requirements.
        </p>

        <p>
          <strong>4. Responsible Gaming: </strong>
          We promote responsible gaming practices. If you feel you may have a
          gambling problem, please seek assistance. We provide self-exclusion
          and limit-setting tools to help you manage your gaming activities
          responsibly.
        </p>

        <p>
          <strong>5. Intellectual Property: </strong>
          All content on Reddy Anna, including logos, graphics, and text, is the
          property of Reddy Anna Book Official and is protected by copyright
          laws. You may not use, reproduce, or distribute our content without
          explicit permission.
        </p>

        <p>
          <strong>6. Financial Transactions:</strong>
          Financial transactions conducted on Reddy Anna are subject to
          applicable laws and regulations. We use secure payment methods to
          protect your financial information. Any attempt at fraudulent
          activities will result in account suspension and legal action.
        </p>

        <p>
          <strong>7. Platform Usage: </strong>
          You agree not to engage in any activities that may disrupt or
          interfere with the proper functioning of Reddy Anna. This includes but
          is not limited to the use of bots, hacking attempts, or any other
          unauthorized means.
        </p>

        <p>
          <strong>8. Termination of Account: </strong>
          Reddy Anna Book Official reserves the right to terminate or suspend
          your account at its discretion, especially in cases of violation of
          these terms and conditions.
        </p>

        <p>
          <strong>9. Changes to Terms: </strong>
          We may update these terms and conditions from time to time. It is your
          responsibility to review the terms regularly. Continued use of our
          platform after changes implies acceptance of the updated terms.
        </p>

        <p>
          <strong>10. Contact Information: </strong>
          If you have any questions or concerns about these terms and
          conditions, please contact us at{' '}
          <a href={ContactLink}>+91 7777947913</a>.
        </p>

        <p style={{color: "#C62E2E"}}>
          Thank you for choosing Reddy Anna Book Official. We strive to provide
          a secure and enjoyable gaming environment for all users.
        </p>
      </div>

      <div className="terms-btn">
      <a
            href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Contact Us @ 7777857777
          </a>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            WhatsApp Us @ 7777077773
          </a>
      </div>
    </section>
  );
};

export default TermsConditions;
